var _path, _path2, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCreditCardPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70,19.25H10a.7502.7502,0,0,0-.75.75V60a.7502.7502,0,0,0,.75.75H70a.7502.7502,0,0,0,.75-.75V20A.7502.7502,0,0,0,70,19.25Zm-.75,40H10.75V32.75h58.5Zm0-28H10.75v-4.5h58.5Zm0-6H10.75v-4.5h58.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16,48.75H28a.7502.7502,0,0,0,.75-.75V40a.7502.7502,0,0,0-.75-.75H16a.7502.7502,0,0,0-.75.75v8A.7502.7502,0,0,0,16,48.75Zm8.75-8h2.5v2.5h-2.5Zm0,4h2.5v2.5h-2.5Zm-8-4h2.5v2.5h-2.5Zm0,4H20a.7502.7502,0,0,0,.75-.75V40.75h2.5v6.5h-6.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 41.25,
    width: 28,
    height: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 45.25,
    width: 16,
    height: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditCardPayment);
export default __webpack_public_path__ + "static/media/icon_credit_card_payment.03f734e1f0e70bb45d1bdb8a6cd52553.svg";
export { ForwardRef as ReactComponent };